module.exports = __webpack_public_path__ + "static/dandelionswaddle-9f31d02eddef0f617269d0410b171849.png";